module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.col.readonly || !_vm.col.input_type) ? _c('span', {
    class: {
      numeric: _vm.col.numeric
    }
  }, [_vm._v("\n  " + _vm._s(_vm.value) + "\n")]) : (_vm.col.input_type === 'text') ? _c('input', {
    class: {
      numeric: _vm.col.numeric
    },
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.col.nullable && _vm.row[_vm.col.name] === null ? '(none)' : null
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "keydown": _vm.blurOnEnter,
      "blur": function($event) {
        _vm.onChange($event.target.value);
        _vm.$forceUpdate()
      }
    }
  }) : (_vm.col.input_type === 'color') ? _c('div', {
    staticClass: "color-wrapper"
  }, [_c('input', {
    staticClass: "input-color",
    style: (_vm.colorStyles),
    attrs: {
      "disabled": _vm.disabled,
      "readonly": ""
    },
    domProps: {
      "value": _vm.row[_vm.col.name]
    },
    on: {
      "click": function($event) {
        _vm.showColorModal = true
      }
    }
  }), _vm._v(" "), (_vm.showColorModal) ? _c('ColorPickerModal', {
    attrs: {
      "value": _vm.row[_vm.col.name]
    },
    on: {
      "close": function($event) {
        _vm.showColorModal = false
      },
      "change": _vm.onChange
    }
  }) : _vm._e()], 1) : (_vm.col.input_type === 'select') ? _c('pretty-select', {
    attrs: {
      "options": _vm.selectData,
      "value": _vm.row[_vm.col.name],
      "disabled": _vm.disabled,
      "editable": _vm.col.editable,
      "type": _vm.col.type,
      "type_id": _vm.col.name,
      "space_id": _vm.row.id
    },
    on: {
      "change": function (val) { return _vm.onChange(val); }
    }
  }) : (_vm.col.input_type === 'texture') ? _c('TextureSelect', {
    attrs: {
      "value": _vm.row[_vm.col.name],
      "disabled": _vm.disabled
    },
    on: {
      "change": function (val) { return _vm.onChange(val); }
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-14ece691!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GenericInput.vue
// module id = 667
// module chunks = 2